export default __webpack_public_path__ + "static/media/2016.af184d48.png";